import { axiosInstance } from 'boot/axios';
import isEmpty from 'lodash/isEmpty';

export function getActivePolicyNumbers({ commit }, payload) {
  var query = 'Policy/GetActivePolicyNumber';
  if (payload) {
    const customerNumber = payload?.customerNumber;
    if (customerNumber) query = query.concat(`?customerNumber=${customerNumber}`);
  }
  return axiosInstance.get(query).then((response) => {
    commit('setActivePolicyNumbers', response.data);
  });
}

export function getExcess({ commit }, payload) {
  var query = 'Policy/GetExcess';
  if (payload) {
    const customerNumber = payload?.customerNumber;
    const year = payload?.year;
    if (customerNumber && year) query = query.concat(`?customerNumber=${customerNumber}&year=${year}`);
  }
  return axiosInstance.get(query).then((response) => {
    commit('setExcessTotal', response.data.amountTotal);
    commit('setExcessRemaining', response.data.amountRemaining);
  });
}

export function getPolicyInfoForYear({ commit }, payload) {
  const policyNumber = payload.policyNumber;
  const customerNumber = payload.customerNumber;
  const year = payload.year;

  commit('addLoadingPolicy', policyNumber);

  axiosInstance
    .get(`/Policy/GetPolicyInfoForYear?customerNumber=${customerNumber}&year=${year}&policyNumber=${policyNumber}`)

    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'agreement/addPolicyToAgreementDetails',
          {
            policyNumber: policyNumber,
            policy: response.data,
          },
          {
            root: true,
          },
        );
        commit('removeLoadingPolicy', policyNumber);
      }
    });
}

export function getFinancialSummary({ commit }, payload) {
  const customerNumber = payload.customerNumber;
  const year = payload.year;

  axiosInstance
    .get(`/Policy/GetFinancialSummary?customerNumber=${customerNumber}&year=${year}`)

    .then((response) => {
      if (!isEmpty(response.data)) {
        commit(
          'customer/addFinancialSummaryToCustomer',
          {
            customerNumber: customerNumber,
            financialSummary: response.data,
          },
          {
            root: true,
          },
        );
      }
    });
}
